import React from "react";


const PageNotFound = () => (
    <div>
        <p>page is not found!!!404</p>
    </div>

);

export default PageNotFound;
